/* tslint:disable */
/* eslint-disable */
/**
 * Scania Configurator
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface GetReadmoreRequest
 */
export interface GetReadmoreRequest {
  /**
   *
   * @type {string}
   * @memberof GetReadmoreRequest
   */
  sessionId: string
  /**
   *
   * @type {string}
   * @memberof GetReadmoreRequest
   */
  itemId: string
}

/**
 * Check if a given object implements the GetReadmoreRequest interface.
 */
export function instanceOfGetReadmoreRequest(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'sessionId' in value
  isInstance = isInstance && 'itemId' in value

  return isInstance
}

export function GetReadmoreRequestFromJSON(json: any): GetReadmoreRequest {
  return GetReadmoreRequestFromJSONTyped(json, false)
}

export function GetReadmoreRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): GetReadmoreRequest {
  if (json === undefined || json === null) {
    return json
  }
  return {
    sessionId: json['sessionId'],
    itemId: json['itemId'],
  }
}

export function GetReadmoreRequestToJSON(
  value?: GetReadmoreRequest | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    sessionId: value.sessionId,
    itemId: value.itemId,
  }
}
